module.exports = "/_next/static/images/prefooter-integrations@2x_f06358b6629d74a24891dac6c20895fd.webp";